module.exports = __webpack_public_path__ + "static/img/10commitments_3.55f4215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_3.jpg
// module id = tRr5
// module chunks = 0